<!-- executive toggle -->
<button mat-icon-button [matMenuTriggerFor]="executiveActions" [matTooltip]="'Configuración'"
  [matTooltipPosition]="'left'">
  <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
</button>

<mat-menu [xPosition]="'before'" #executiveActions="matMenu">
  <div class="row text-center ">
    <div class="col-12 text-base text-center text-bxBlue">Configuración</div>
    <mat-divider class="mb-1"></mat-divider>
  </div>
  <ng-container *ngFor="let btn of listaNodos; let idxNodo = index ">
    <button mat-menu-item class=" my-2  " *ngIf="!btn.hide" (click)="goLink (btn)">
      <mat-icon class="icon-size-5 text-green-500" [svgIcon]="btn.icon"></mat-icon>
      <div class=" text-base font-normal" [ngClass]="{'text-blue': linkActive[idxNodo]}"> {{btn.descripcion |
        firstMayus}}
        <div class=" text-xs font-light"> {{btn.descripcionState | firstMayus}}</div>
      </div>
    </button>
  </ng-container>
</mat-menu>